<template>
  <v-card
    :loading="computed_loading"
    :disabled="computed_loading"
    elevation="0"
  >
    <v-card-text class="pa-0">
      <div class="text-center">
        <h2>
          {{ $t("pre_regis_complete.list_of_registered_subjects") }}
        </h2>
        <v-simple-table dense class="mt-2">
          <template v-slot:default>
            <thead>
              <!-- --------------------------------------------------------------- -->
              <!-- Table Header -->
              <tr>
                <th class="text-center" style="min-width: 120px">
                  {{ $t("pre_regis_add_subject.subject_id") }}
                </th>
                <th class="text-center" style="min-width: 150px">
                  {{ $t("pre_regis_add_subject.subject_name") }}
                </th>
                <th class="text-center">
                  {{ $t("pre_regis_add_subject.credit") }}
                </th>
                <th class="text-center" style="min-width: 80px; width: 80px">
                  {{ $t("pre_regis_add_subject.section") }}
                </th>
                <!-- <th class="text-center">
                  {{ $t("pre_regis_add_subject.type") }}
                </th> -->
                <th class="text-center">
                  {{ $t("pre_regis_add_subject.class_exam_timetable") }}
                </th>
                <th class="text-center">
                  {{ $t("pre_regis_add_subject.limit") }}
                </th>
                <th class="text-center last-cell">
                  {{ $t("regis_add_subject.number_of_people_registered") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <!-- --------------------------------------------------------------- -->
              <!-- Table Display registered -->
              <tr v-if="regis_type == 'M'">
                <td class="last-cell text-center" colspan="8">
                  <h2 class="ma-2 blue--text">{{ $t("registration.regis_type_m_status") }}</h2>
                </td>
              </tr>
              <tr v-if="regis_type == 'D'">
                <td class="last-cell text-center" colspan="8">
                  <h2 class="ma-2 blue--text">{{ $t("registration.regis_type_d_status") }}</h2>
                </td>
              </tr>
              <tr
                v-for="item in computed_registering_subject_list"
                :key="item.name"
              >
                <td :class="get_class(item)">
                  <span v-if="!(item.has_pair && item.lect_or_prac === 'ป')">{{
                    item.subject_id
                  }}</span>
                </td>
                <td :class="get_class(item)">
                  <a
                    v-if="!(item.has_pair && item.lect_or_prac === 'ป')"
                    class="subject-link"
                    @click="openSubjectDialog(item.subject_id)"
                  >
                    {{ item.subject_ename }}
                  </a>
                </td>
                <td :class="get_class(item)">
                  <span v-if="!(item.has_pair && item.lect_or_prac === 'ป')">
                    <class-hour-text :item="item"></class-hour-text>
                  </span>
                </td>
                <td class="full-width text-right">
                  {{ item.section }}
                  <lect-or-prac-chip :item="item"></lect-or-prac-chip>
                  {{
                    item.has_same_section ? " (" + item.curr2_tname + ")" : ""
                  }}
                </td>
                <!-- <td>Cr</td> -->
                <td class="full-width">
                  <teach-and-exam-time :item="item"></teach-and-exam-time>
                </td>
                <td>{{ item.LIMIT != "0" ? item.LIMIT : "-" }}</td>
                <td class="last-cell">{{ item.COUNT }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <add-change-delete
          v-if="
            (change_period || withdraw_period || bypass) && regis_type == 'S'
          "
          :computed_registering_subject_list="computed_registering_subject_list"
          :getRegisResult="getRegisResult"
          :get_queue_list="get_queue_list"
          :transactions_fetched="transactions_fetched"
          :getRegisTransaction="getRegisTransaction"
          :withdraw_period="withdraw_period"
          :change_period="change_period"
          :year="year"
          :semester="semester"
          :student_id="student_id"
          :bypass="bypass"
        ></add-change-delete>
        <v-divider v-if="change_period" class="mt-5 mb-2"></v-divider>
        <queue-table-panel
          v-if="change_period && !bypass"
          :get_queue_list="get_queue_list"
          :queue_invalid_list="queue_invalid_list"
          :queue_granted_list="computed_queue_granted_list"
          :queued_subject_list="queued_subject_list"
          :change_period="change_period"
          :view_invalid="view_invalid"
          :invalid_queue_fetched="invalid_queue_fetched"
          :year="year"
          :semester="semester"
          :student_id="student_id"
          :bypass="bypass"
        ></queue-table-panel>
        <v-divider class="mt-5 mb-5"></v-divider>
        <v-btn
          outlined
          class="dark"
          v-if="!transactions_fetched"
          @click="getRegisTransaction()"
        >
          {{ $t("registration.view_transaction") }}
        </v-btn>
        <regis-transaction
          v-if="transactions_fetched"
          :regis_transactions="regis_transactions"
        ></regis-transaction>
        <subject-dialog ref="subject_dialog" />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { parseDate_Time } from "@/helper/registration";
import ClassHourText from "./ClassHourText.vue";
import TeachAndExamTime from "./TeachAndExamTime.vue";
import RegistrationProvider from "@/services/registration.provider.js";
import LectOrPracChip from "./LectOrPracChip.vue";
import QueueTablePanel from "./QueueTablePanel.vue";
import AddChangeDelete from "./AddChangeDelete.vue";
import RegisTransaction from "./RegisTransaction.vue";
import SubjectDialog from "@/views/teach_table/components/SubjectDialog.vue";

const RegistrationService = new RegistrationProvider();
export default {
  name: "RegisComplete",
  components: {
    ClassHourText,
    TeachAndExamTime,
    LectOrPracChip,
    QueueTablePanel,
    AddChangeDelete,
    RegisTransaction,
    SubjectDialog,
  },
  props: {
    clickNext: {
      type: Function,
    },
    change_period: {
      type: Boolean,
      default: false,
    },
    withdraw_period: {
      type: Boolean,
      default: false,
    },
    regis_type: {
      type: String,
    },
    year: {
      type: String,
    },
    semester: {
      type: String,
    },
    student_id: {
      type: String,
    },
    bypass: {
      type: Boolean,
      default: null,
    },
  },
  data: () => ({
    loading_regis_result: false,
    loading_queue: false,
    loading_transaction: false,
    registering_subject_list: [],

    queue_invalid_list: [],
    queue_granted_list: [],
    queued_subject_list: [],
    rejected_queue_list: [],

    regis_transactions: [],

    transactions_fetched: false,
    invalid_queue_fetched: false,
  }),
  computed: {
    computed_loading() {
      if (
        this.loading_regis_result ||
        this.loading_regis_result ||
        this.loading_transaction
      )
        return true;
      else return false;
    },
    in_granted_but_not_use() {
      return this.computed_queue_granted_list.filter(
        (item) => !item.registering
      );
    },
    computed_queue_granted_list() {
      return this.queue_granted_list.map((item) => ({
        ...item,
        registering: this.is_in_registering(item.subject_id, item.section),
      }));
    },
    // จะแปลงพวกวันเรียน วันสอบ ให้อยู่ในตัวแปรที่เหมาะสมต่อการแสดง
    computed_registering_subject_list() {
      const temp = this.registering_subject_list.map((item) => {
        const same_subject = this.registering_subject_list.filter(
          (item_2) => item_2.subject_id === item.subject_id
        );
        if (same_subject.length > 1) {
          return { ...item, has_pair: true };
        } else return { ...item, has_pair: false };
      });
      return temp
        .map((item) => parseDate_Time(item))
        .sort((a, b) => {
          if (a.subject_id > b.subject_id) return 1;
          if (a.subject_id < b.subject_id) return -1;
          if (a.subject_id == b.subject_id) {
            if (a.lect_or_prac === "ป") return 1;
            return -1;
          }
          return 0;
        });
    },
  },
  methods: {
    openSubjectDialog(subjectId) {
      if (this.$refs.subject_dialog) {
        this.$refs.subject_dialog.show_item_detail(subjectId);
      }
    },
    view_invalid() {
      this.invalid_queue_fetched = true;
      this.get_invalid_queue();
    },
    is_in_registering(teach_table_id) {
      // เอาไว้แสดงสีของตัวที่ได้สิทธิ์ว่าอันไหนกำลังลงอยู่ จะได้มองเห็นง่ายๆ
      return this.registering_subject_list.reduce(
        (ret, item) => ret || item.teach_table_id == teach_table_id,
        false
      );
    },
    async get_invalid_queue() {
      if (this.invalid_queue_fetched) {
        const data_2 = await RegistrationService.getInvalidQueue({
          student_id: this.student_id,
          year: this.year,
          semester: this.semester,
          level_id: "1",
        });
        this.queue_invalid_list = data_2;
      }
    },
    async get_queue_list(only_queue = false) {
      this.loading_queue = true;
      // ถ้าส่งมาว่า only queue จะไม่โหลดอันที่ได้สิทธิ์
      if (!only_queue) {
        const data_1 = await RegistrationService.getQueueGrantedList({
          student_id: this.student_id,
          year: this.year,
          semester: this.semester,
          level_id: "1",
        });
        this.queue_granted_list = data_1;
      }

      await this.get_invalid_queue();

      const data_3 = await RegistrationService.getQueueSubjectList({
        student_id: this.student_id,
        year: this.year,
        semester: this.semester,
        level_id: "1",
      });
      this.queued_subject_list = data_3;
      this.loading_queue = false;
    },
    get_class(item) {
      if (item.has_pair && item.lect_or_prac === "ท") return "no_bottom_line ";
      if (item.has_pair && item.lect_or_prac === "ป") return "no_top_line ";
      return "";
    },
    async getRegisResult() {
      try {
        this.loading_regis_result = true;
        const data = await RegistrationService.getRegisResult({
          student_id: this.student_id,
          year: this.year,
          semester: this.semester,
          level_id: "1",
        });
        this.registering_subject_list = data;
        this.loading_regis_result = false;
      } catch (error) {
        this.$toasted.error(JSON.stringify(error.response.data.message), {
          duration: 0,
        });
        this.loading_regis_result = false;
      }
    },
    async getRegisTransaction() {
      this.loading_transaction = true;
      try {
        const data = await RegistrationService.getRegisTransaction({
          student_id: this.student_id,
          year: this.year,
          semester: this.semester,
          level_id: "1",
        });
        this.regis_transactions = data;
      } catch (error) {
        this.$toasted.error(JSON.stringify(error.response.data.message), {
          duration: 0,
        });
      }
      this.transactions_fetched = true;
      this.loading_transaction = false;
    },
    async fetchInit() {
      await this.getRegisResult();
    },
  },
  created() {
    this.fetchInit();
  },
};
</script>

<style lang="scss" scoped>
td {
  border-width: 0px;
  border-left-width: 1px;
  border-bottom-width: 1px;
  border-style: solid;
  border-color: #ccc;
}
.last-cell {
  border-right-width: 1px;
}
thead {
  background-color: #ffbd43;
}

th {
  padding: 0;
  overflow: hidden;
  white-space: nowrap;
}

.full-width {
  overflow: hidden;
  white-space: nowrap;
}

.no_bottom_line {
  border-bottom-width: 0px !important;
}
.no_top_line {
  border-top-width: 0px !important;
}

.subject-link {
  color: #1976d2;
  cursor: pointer;
  text-decoration: none;
  font-weight: inherit;
}

.subject-link:hover {
  text-decoration: none;
}
</style>
